<template>
  <v-card>
    <v-card-title>
      Course Name: {{course.name}}
      <v-tooltip left>
        <template v-slot:activator="{ on }">
        <v-btn class="ml-auto" @click="syncEventAttendees" icon v-on="on">
          <v-icon>mdi-calendar-sync-outline</v-icon>
        </v-btn>
        </template>
        <span>Sync Attendees with Google Calendar</span>
      </v-tooltip>
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="12" lg="4">
          {{invitations && invitations.length > 0 ? "Invitations":"No invitations pending"}}
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="(invitation) in invitations" :key="invitation.id">
                <v-list-item-content>{{invitation.email}} ({{invitation.role}})</v-list-item-content>
                <v-list-item-action>
                  <v-btn icon @click="deleteInvitation(invitation)" :disabled="isAppLoading">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col cols="12" lg="4">
          Teachers
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="(t) in course.courseTeachers" :key="t.teacherId">
                <v-list-item-content>{{t.teacher.firstName}} {{t.teacher.lastName}} ({{t.teacher.email}})</v-list-item-content>
                <v-list-item-action>
                  <v-btn @click="removeTeacher(t)" icon :disabled="isAppLoading">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
        <v-col cols="12" lg="4">
          Students
          <v-list>
            <v-list-item-group>
              <v-list-item v-for="(s) in course.courseStudents" :key="s.studentId">
                <v-list-item-content>{{s.student.firstName}} {{s.student.lastName}}</v-list-item-content>
                <v-list-item-action>
                  <v-btn @click="removeStudent(s)" icon :disabled="isAppLoading">
                    <v-icon>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-col>
      </v-row>
      <v-divider class="my-8" />
      <v-text-field v-model="teacher" :rules="emailRules" outlined label="Teacher's Email" />
      <v-btn @click="inviteTeacher" :disabled="isAppLoading">Invite Teacher</v-btn>
      <v-divider class="my-8" />
      <v-autocomplete
        v-model="selectCustomer"
        :loading="isAppLoading"
        :items="customers"
        :search-input.sync="search"
        :filter="customerFilter"
        item-text="name"
        item-value="id"
        cache-items
        flat
        hide-no-data
        hide-details
        return-object
        label="Search for customers by name, email or phone number"
        outlined
      >
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title v-html="data.item.name"></v-list-item-title>
              <v-list-item-subtitle>{{data.item.group}} ({{data.item.email ? data.item.email:'No Email'}})</v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
      <div style="text-align: center" class="my-3">OR</div>
      <v-text-field v-model="student" :rules="emailRules" outlined label="Student's Email" />
      <v-btn @click="inviteStudent" :disabled="isAppLoading">Invite Student</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: ["course", "events"],
  data() {
    return {
      valid: true,
      teacher: null,
      student: null,
      invitations: [],
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+\..+/.test(v) || "E-mail must be valid"
      ],
      customers: [],
      selectCustomer: null,
      search: null
    };
  },
  watch: {
    search(query) {
      if (query && (!this.select || this.select.text !== query)) {
        this.queryCustomers(query);
      }
    },
    selectCustomer(obj) {
      if (obj && obj.email && obj.email != "null") this.student = obj.email;
    }
  },
  computed: {
    ...mapGetters(["navState", "isAppLoading"])
  },
  created() {
    this.pullInvitationList();
  },
  mounted() {},
  methods: {
    ...mapActions(["hideDialog", "addErrorMessage"]),
    inviteTeacher() {
      const params = {
        courseId: this.course.googleCourseId,
        teacherEmail: this.teacher
      };
      this.$axios
        .post("/classroom/course/invite/teacher", null, { params })
        .then(() => {
          this.invitations = this.pullInvitationList();
        })
        .then(() => {
          this.$store.dispatch("addMessage", {
            message: "Invitation sent to teacher: " + this.teacher,
            messageClass: "success"
          });
        })
        .catch(err => {
          const message = err.data;
          this.$store.dispatch("addMessage", {
            message,
            messageClass: "danger"
          });
        });
    },
    inviteStudent() {
      const params = {
        courseId: this.course.googleCourseId,
        courseOwner: this.course.courseOwner.email,
        studentEmail: this.student
      };
      this.$axios
        .post("/classroom/course/invite/student", null, { params })
        .then(() => {
          this.invitations = this.pullInvitationList();
        })
        .then(() => {
          this.$store.dispatch("addMessage", {
            message: "Invitation sent to student: " + this.student,
            messageClass: "success"
          });
        })
        .catch(err => {
          const message = err.data;
          this.$store.dispatch("addMessage", {
            message,
            messageClass: "danger"
          });
        });
    },
    deleteInvitation(invitation) {
      const params = { invitationId: invitation.googleCourseInvitationId };
      this.$axios
        .post("/classroom/course/delete/invitation", null, { params })
        .then(() => {
          this.invitations.splice(
            this.invitations.findIndex(v => v.id === invitation.id),
            1
          );
        })
        .catch(err => {
          const message = err.data;
          this.addErrorMessage(message);
        });
    },
    removeTeacher(courseTeacher) {
      const params = { courseTeacherId: courseTeacher.id };
      this.$axios
        .post("/course/teacher/remove", null, { params })
        .then(() => {
          this.course.courseTeachers.splice(
            this.course.courseTeachers.findIndex(
              ct => ct.id == courseTeacher.id
            ),
            1
          );
        })
        .catch(err => {
          const message = err.data;
          this.addErrorMessage(message);
        });
    },
    removeStudent(courseStudent) {
      const params = { courseStudentId: courseStudent.id };
      this.$axios
        .post("/course/student/remove", null, { params })
        .then(() => {
          this.course.courseStudents.splice(
            this.course.courseStudents.findIndex(
              cs => cs.id == courseStudent.id
            ), 1 );
        })
        .catch(err => {
          const message = err.data;
          this.addErrorMessage(message);
        });
    },
    customerFilter(item, queryText) {
      const name = item.name.toLowerCase();
      // const hasEmail = item.email && item.email != 'null' || false
      const hasEmail = true;
      const searchText = queryText.toLowerCase();

      return hasEmail && name.indexOf(searchText) > -1;
    },
    queryCustomers(term) {
      // cancel pending call
      clearTimeout(this._timerId);

      // delay new call 500ms
      this._timerId = setTimeout(() => {
        this.customers = []; //reset customer list
        const data = { searchTerm: term, searchEntities: ["RP", "STUDENT"] };
        this.$axios.post("search", data).then(resp => {
          const searchResults = resp.data;
          const rps = searchResults.rps;
          const results = [];
          if (rps && rps.length > 0) {
            rps.forEach(rp => {
              const name = `${rp.firstName} ${rp.lastName}`;
              const email = rp.email;
              const id = `RP_${rp.id}`;
              const group = "Guardians";
              results.push({ id, name, group, email });
            });
          }
          const students = searchResults.students;
          if (students && students.length > 0) {
            students.forEach(student => {
              const name = `${student.firstName} ${student.lastName}`;
              const email = student.email;
              const id = `Student_${student.id}`;
              const group = "Students";
              results.push({ id, name, group, email });
            });
          }

          console.log(results);

          this.customers = results;
        });
      }, 500);
    },
    syncEventAttendees() {
      const params = { googleCourseId: this.course.googleCourseId };
      this.$axios
        .post("classroom/course/event/sync/attendees", null, {params})
        .then((resp) => {
          const event2Attendees = resp.data;
          console.log(event2Attendees)
          this.events.forEach( (event) => {
            if(Array.isArray(event.attendees) && event.attendees.length > 0){
              event.attendees.concat(event2Attendees[event.id]);
            }
            else{
              event.attendees = event2Attendees[event.id];
            }
          })
          this.$store.dispatch(
            "addSuccessMessage",
            "Attendees sync with calendar events"
          );
        })
        .catch(err => {
          const message = err.data;
          this.$store.dispatch("addErrorMessage", message);
        });
    },
    pullInvitationList() {
      const params = { courseId: this.course.googleCourseId };
      this.$axios
        .get("/classroom/course/invitations", { params })
        .then(resp => {
          this.invitations = resp.data;
        })
        .catch(err => {
          const message = err.data;
          this.$store.dispatch("addMessage", {
            message,
            messageClass: "danger"
          });
        });
    }
  }
};
</script>

<style>
</style>